import React from 'react';

import {useHistory, useParams} from 'react-router-dom';

import ButtonSection from '../../components/buttons/button-section/button-section';
import {goToDirection} from '../../utils/utils';
import MapPinContent from './map-pin-content';

import './map-pin-info.scss';

export default function MapPinInfo(props: any) {

    const {id}: any = useParams();
    const history = useHistory();
    const txtButtons = props.buttons ? props.buttons : [];

    const redirectMoreInfo = () => {
        history.push(`/stop/${id}/detail`);
    };

    return (<>
        <MapPinContent
            icon={props.icon}
            title={props.title}
            description={props.description}
            accessibility={props.accessibility}
            distance={props.distance}
            type={props.type}
            slug={props.slug}
            lines={props.lines}
            pinType={props.pinType}
            hasAlert={props.hasAlert}
            alertId={props.alertId}
        />
        {
            !!txtButtons.length && <ButtonSection
                txtButtons={txtButtons}
                redirectMoreInfo={redirectMoreInfo}
                goToDirection={() => goToDirection(props.coord?.lat, props.coord?.lng)}
                slug={props.slug}
            />
        }
    </>);
}
